import ActionType from "../../Actions/ActionType";
import { equipmentMasterAction } from "../../Actions/EquipmentMaster/EquipmentMasterAction";

const intialState = {
  filterData: {},
  search: '',
  updateEquipmentMaster:false,
};
const equipmentMasterReducer = (state: object = intialState, action: equipmentMasterAction) => {
  switch (action.type) {
    case ActionType.SET_EQUIPMENT_MASTER_FILTER:
      return {
        ...state,
        filterData: action.data,
      };
      case ActionType.SET_SEARCH:
        return {
          ...state,
          search: action.data,
      };
      case ActionType.UPDATE_EQUIPMENT_MASTER:
        return {
          ...state,
          updateEquipmentMaster: action.data,
        };
    default:
      return state;
  }
};
export default equipmentMasterReducer;